export const CANCEL_SOCIAL_REGISTRATION_ACTION = "cancel-social-registration";
export const COMPLETE_SOCIAL_REGISTRATION_ACTION = "complete-social-registration";
export const REGISTRATION_REQUIRED = "registration-required";
